<div class="badge-item">
  <div class="badge-container">
    <div class="badge-item-header">
      <span class="badge-title">{{ item.title }}</span>
      <span class="badge-subtitle">{{ item.description }}</span>
    </div>
  </div>
</div>
